import IUser from './user.model';

export interface ISearchResponse {
  deviceModels?: string[];
  manufacturers?: string[];
  udids?: string[];
  users?: IUser[];
  tags?: string[];
  appVersions?: string[];
}

export enum SearchParam {
  MESSAGE = 'msg',
  REGEX = 'regex',
  MANUFACTURER = 'manufacturer',
  DEVICE_MODEL = 'deviceModel',
  UDID = 'udid',
  UUID = "uuid",
  ANDROID_ID = "androidId",
  APP_VERSION = 'appVersion',
  OS_VERSION = 'osVersion',
  OS_NAME = 'osName',
  LANGUAGE = 'language',
  TAG = 'tag',
  USER_ID = 'userId',
  USER_NAME = 'userName',
  FULL_NAME = 'fullName',
  EMAIL = 'email',
  PHONE_NUMBER = 'phoneNumber',
  SESSION = 'session',
  JOB_NAME = 'jobName',
  FLOW = 'flow',
  REQUEST_ID = 'requestId',
  CLASS_NAME = 'className',
  FILE_NAME = 'fileName',
  BASE_FILE_NAME = 'baseFileName',
  LINE_NUMBER = 'lineNumber',
  LOG_ID = 'logId',
  HAS_ID = 'hasId',
  FROM_TIME = 'fromTime',
  TO_TIME = 'toTime',
  KEY = 'key',
  SEARCH_AFTER = 'searchAfter'
}

export enum SearchMeta  {
  SEVERITY = 'severity',
  MIN_SEVERITY = 'min_severity',
  TYPE = 'type',
  INTERVAL = 'interval',
  RANGE = 'range'
}

export enum RangeMode {
  QUARTER_HOUR = '15m',
  HOUR = '1h',
  DAY = '24h',
  WEEK = '7d',
  ALL = 'all'
}

export type SearchType = SearchParam | string;

export function searchParamTitle(searchType: SearchType) {
  switch (searchType) {
      case SearchParam.MESSAGE:
        return 'Free text - Message';
      case SearchParam.REGEX:
        return 'RegEx - Message';
      case SearchParam.MANUFACTURER:
        return 'Manufacturer';
      case SearchParam.DEVICE_MODEL:
        return 'Device Model';
      case SearchParam.UDID:
        return 'UDID';
      case SearchParam.UUID:
        return 'UUID';
      case SearchParam.ANDROID_ID:
        return 'Android ID'
      case SearchParam.APP_VERSION:
        return 'App Version';
      case SearchParam.OS_VERSION:
        return 'OS Version';
      case SearchParam.OS_NAME:
        return 'OS Name';
      case SearchParam.LANGUAGE:
        return 'Language';
      case SearchParam.TAG:
        return 'Tag';
      case SearchParam.USER_ID:
        return 'User ID';
      case SearchParam.USER_NAME:
        return 'User name';
      case SearchParam.FULL_NAME: 
        return 'User Full Name';
      case SearchParam.EMAIL:
        return 'User Email';
      case SearchParam.PHONE_NUMBER:
        return 'User Phone Number';
      case SearchParam.FROM_TIME:
        return 'From Time';
      case SearchParam.TO_TIME:
        return 'To Time';
      case SearchParam.JOB_NAME:
        return 'Job Name';
      case SearchParam.FLOW:
        return 'Flow';
      case SearchParam.REQUEST_ID:
        return 'Request';
      case SearchParam.CLASS_NAME:
        return 'Class Name';
      default:
        return searchType;
  }
}

export class CustomOption {
  label: string;
  value: string;
  type: SearchType;

  static createSearchParam(type: SearchType) {
    const label = searchParamTitle(type);
    return new CustomOption(type, `${label} (${type}:)`, '');
  }

  constructor(type: SearchType, label: string, value: string) {
    this.type = type;
    this.label = label;
    this.value = value;
  }

}

export enum DateType {
  TEN_MINUTES = '10 Minutes',
  HOUR = 'Hour',
  DAY = 'Day',
  MONTH = 'Month',
  NOW = 'Now',
  CUSTOM = 'Custom'
}


export class DateTypeUtil {
  static values() {
    return Object.values(DateType);
  }
}
